module.exports = __webpack_public_path__ + "img/icon-menu-on.86712f5.webp";